module.exports = __webpack_public_path__ + "static/bg-2dadc21f6cd89e70d1c7a00bc1c582a3.jpg";